import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import ShowCard from '../components/ShowCard';
import { Heart, Tv } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FavoritesPage() {
  const { user } = useAuth();
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      axios.get(`${API}/favorites`, { withCredentials: true })
        .then(r => { setShows(r.data); setLoading(false); })
        .catch(() => setLoading(false));
    }
  }, [user]);

  if (!user) {
    return (
      <div className="page-content min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <Heart size={48} className="text-[#FF3860] mx-auto mb-4" strokeWidth={1.5} />
          <p className="font-['Fredoka'] text-2xl text-[#0A0A0A] mb-2">Sign in to see favorites</p>
          <Link to="/login" className="neo-btn inline-block px-6 py-2 rounded-xl bg-[#FF3860] text-white text-sm" data-testid="favorites-login-btn">
            Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 py-8">
        <div className="flex items-center gap-3 mb-8">
          <Heart size={28} strokeWidth={2.5} className="text-[#FF3860]" />
          <h1 className="font-['Fredoka'] text-4xl sm:text-5xl font-black text-[#0A0A0A] tracking-tight" data-testid="favorites-title">
            My Favorites
          </h1>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="neo-card animate-pulse">
                <div className="aspect-video bg-gray-200" />
                <div className="p-4 space-y-2">
                  <div className="h-5 bg-gray-200 rounded w-3/4" />
                  <div className="h-4 bg-gray-200 rounded w-full" />
                </div>
              </div>
            ))}
          </div>
        ) : shows.length === 0 ? (
          <div className="text-center py-20" data-testid="no-favorites">
            <Tv size={48} className="text-[#4B5563] mx-auto mb-4" strokeWidth={1.5} />
            <p className="font-['Fredoka'] text-2xl text-[#4B5563] mb-2">No favorites yet</p>
            <p className="text-sm text-[#4B5563] font-['Nunito'] mb-6">Browse shows and add them to your favorites!</p>
            <Link to="/browse" className="neo-btn inline-block px-6 py-2 rounded-xl bg-[#FF3860] text-white text-sm" data-testid="browse-shows-btn">
              Browse Shows
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 stagger-children">
            {shows.map((show, i) => (
              <div key={show.id} className="animate-fade-in-up" style={{ opacity: 0 }}>
                <ShowCard show={show} index={i} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
